import React from 'react';
import PropTypes from 'prop-types';
import Text from '../../Text';
import { dataHooks } from '../constants';
import styles from '../Notification.st.css';

var TextLabel = function TextLabel(_ref) {
  var children = _ref.children,
      ellipsis = _ref.ellipsis;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement(Text, {
    ellipsis: ellipsis,
    light: true,
    dataHook: dataHooks.notificationLabel
  }, children));
};

TextLabel.propTypes = {
  ellipsis: PropTypes.bool,
  children: PropTypes.node
};
TextLabel.defaultProps = {
  ellipsis: true
};
TextLabel.displayName = 'Notification.TextLabel';
export default TextLabel;